import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import React, { PropsWithChildren } from 'react'
import styled from 'styled-components'

const Container = styled(VerticalSpacer)`
  grid-area: details;
`

function AccommodationSameRoomOptionTileDetails({ children }: PropsWithChildren) {
  return <Container gap={12}>
    {children}
  </Container>
}

export default AccommodationSameRoomOptionTileDetails
